import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

// Base API URL for websites
const API_URL = BaseUrl.baseUrl + 'websites';

// Function to get token from localStorage
const getToken = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? user.token : null;
};

// Function to handle errors
const handleError = (error) => {
    throw new Error(error.response ? error.response.data.message : 'An error occurred');
};

// Create a new website
const createWebsite = async (websiteDTO) => {
    const token = getToken();
    try {
        const response = await axios.post(API_URL, websiteDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get website by ID
const getWebsiteById = async (id) => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get websites with pagination
const getWebsites = async (page = 0, size = 10) => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}/page?page=${page}&size=${size}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get All websites pagination
const getAllWebsites = async () => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}/all`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Update a website by ID
const updateWebsite = async (id, websiteDTO) => {
    const token = getToken();
    try {
        const response = await axios.put(`${API_URL}/${id}`, websiteDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Delete a website by ID
const deleteWebsite = async (id) => {
    const token = getToken();
    try {
        await axios.delete(`${API_URL}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Export all methods as WebService
const WebsiteService = {
    createWebsite,
    getWebsiteById,
    getAllWebsites,
    getWebsites,
    updateWebsite,
    deleteWebsite,
};

export default WebsiteService;
